import getElementForCfi from 'utilities/locationLogic/getElementForCfi';
import getPixelsForCfi from 'utilities/locationLogic/getPixelsForCfi';

/**
 * @method scrollToCfi
 * @param {Element} frame
 * @param {String} cfi
 */
const scrollToCfi = (frame, cfi) => {
  const elementObject = getElementForCfi(frame, cfi);

  if (!elementObject) {
    throw new Error(
      'Failed to scroll to CFI. Could not obtain target element.',
    );
  }

  let pixelForCfi = getPixelsForCfi(frame, cfi);

  frame.parentElement.parentElement.scrollTop = Math.ceil(pixelForCfi);
};

export default scrollToCfi;
